module.exports = __webpack_public_path__ + "img/work-up.b8bec33d.png";